var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:['typing', _setup.props.theme]},[_c('div',{staticClass:"typing__dot"}),_vm._v(" "),_c('div',{staticClass:"typing__dot"}),_vm._v(" "),_c('div',{staticClass:"typing__dot"})])
}
var staticRenderFns = []

export { render, staticRenderFns }